<template>
    <main class="p-4 min-h-screen bg-gray-200"
        @keyup.enter="reset">
        <div class="sm:w-1/2 lg:w-1/3 mx-auto md:mt-8">
            <div class="card">
                <h1 class="card-header flex items-center">
                    <router-link 
                        :to="{name: 'login'}" 
                        class="btn btn-blue py-0 px-1"
                    ><back-icon /></router-link>
                    <span class="ml-3">Choose a new password</span>
                </h1>
                <div class="card-body">                    
                    <div class="p-3 rounded bg-red-500 text-white mb-6"
                        v-if="errorMessage">{{ errorMessage }}</div>
                    <div class="form-group">
                        <app-input type="password"
                            v-model="form.password"
                            placeholder="New Password"
                            focus
                            :error="form.errors.get('password')"
                            @updated="form.errors.clear('password')"></app-input>
                    </div>
                    <div class="form-group">
                        <app-input type="password"
                            v-model="form.password_confirmation"
                            placeholder="Confirm New Password"
                            :error="form.errors.get('password_confirmation')"
                            @updated="form.errors.clear('password_confirmation')"></app-input>
                    </div>
                    <div>
                        <app-button @click="reset"
                            :loading="loading"
                            class="btn-blue btn-lg btn-block">Reset Password</app-button>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
    import Form from '../helpers/Form'
    export default {
        components: {
            BackIcon: () => import('@/icons/ArrowBack.vue'),
        },
        data() {
            return {
                form: new Form({
                    email: this.$route.query.email,
                    password: '',
                    password_confirmation: '',
                    token: this.$route.params.token
                }),
                loading: false,
                errorMessage: null
            }
        },
        methods: {
            reset() {
                this.loading = true
                this.form.errors.clear()
                this.$store.dispatch('auth/passwordReset', this.form.payload())
                    .then(({data}) => {
                        this.loading = false
                        this.$swal.fire({
                            type: 'success',
                            title: 'Success!',
                            text: data.message
                        })
                        
                        this.$router.push({name: 'login'})
                    })
                    .catch(({response}) => {
                        this.loading = false
                        if (response.data.errors) {
                            this.form.errors.record(response.data)
                        }
                        if (response.data.errorMessage) {
                            this.errorMessage = response.data.message
                        }
                    })
            }
        }
    }
</script>